module.exports = __webpack_public_path__ + "img/policy-action-plan.b7ee9470.png";